/**
 * Descreve a contagem de cadastros vinculados a um tipo tributário, distinguindo pessoas de
 * vendedores (vendedor tem id_tipo_tributario próprio e é contado à parte pela API Pessoa).
 */
export function formatarCadastrosVinculados(totalPessoas: number, totalVendedores: number): string {
  if (totalVendedores === 0) return `${totalPessoas} cadastro(s) de pessoa`;
  if (totalPessoas === 0) return `${totalVendedores} vendedor(es)`;
  return `${totalPessoas} cadastro(s) de pessoa e ${totalVendedores} vendedor(es)`;
}
